import { Colors } from '../../theme/Colors';
import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

const StyledAnchor = styled(Link)({
    color: Colors.white,
    backgroundColor: Colors.primary,
    padding: '10px 20px',
    borderRadius: 25,
    fontWeight: 'bold',
    boxShadow: '#807E7D80 0px 3px 6px',
    '&:hover': {
        color: Colors.white,
        textDecoration: 'none',
    },
    textAlign: 'center',
    fontFamily: 'Outfit',
});

export default StyledAnchor;
